import { ArrowRight } from "lucide-react";

export default function Hero() {
    const scrollTo = (id) => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section
            id="hero"
            data-testid="section-hero"
            className="relative min-h-screen w-full flex items-center overflow-hidden"
        >
            {/* Background image */}
            <div className="absolute inset-0">
                <img
                    src="/portfolio/IMG-20260514-WA0107.jpg"
                    alt="Parquet in rovere europeo select spazzolato realizzato da Dogaparquet"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-ink-900/70 via-ink-800/60 to-ink-900" />
            </div>

            <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 w-full">
                <div className="max-w-3xl pt-24">
                    <p
                        data-testid="hero-overline"
                        className="text-xs uppercase tracking-widest text-brass mb-8 animate-fade-up"
                    >
                        Dogaparquet — Modica · Ragusa · Sicilia
                    </p>

                    <h1
                        data-testid="hero-headline"
                        className="font-serif font-light text-cream text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight animate-fade-up"
                        style={{ animationDelay: "120ms" }}
                    >
                        L’arte del legno,
                        <br />
                        <span className="italic text-brass">
                            la qualità che dura
                        </span>
                        .
                    </h1>

                    <p
                        data-testid="hero-subheadline"
                        className="mt-8 text-lg lg:text-xl text-cream/75 max-w-xl leading-relaxed animate-fade-up"
                        style={{ animationDelay: "240ms" }}
                    >
                        Da oltre vent’anni Gianluca Occhipinti realizza
                        pavimenti in legno su misura: posa, restauro e
                        consulenza per residenze e spazi commerciali.
                    </p>

                    <div
                        className="mt-12 flex flex-wrap items-center gap-6 animate-fade-up"
                        style={{ animationDelay: "360ms" }}
                    >
                        <button
                            type="button"
                            data-testid="hero-cta-button"
                            onClick={() => scrollTo("#contatti")}
                            className="group inline-flex items-center gap-3 bg-brass hover:bg-brass-light text-ink-900 px-8 py-4 text-sm tracking-widest uppercase transition-colors duration-500"
                        >
                            Richiedi un preventivo
                            <ArrowRight
                                size={16}
                                className="transition-transform duration-500 group-hover:translate-x-1"
                            />
                        </button>
                        <button
                            type="button"
                            data-testid="hero-cta-portfolio"
                            onClick={() => scrollTo("#portfolio")}
                            className="link-underline text-sm tracking-widest uppercase text-cream/80 hover:text-cream transition-colors duration-500"
                        >
                            Scopri i progetti
                        </button>
                    </div>
                </div>
            </div>

            {/* Bottom marker */}
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3 text-cream/50">
                <span className="text-[10px] uppercase tracking-widest">
                    Scroll
                </span>
                <span className="w-px h-12 bg-cream/30" />
            </div>
        </section>
    );
}
